import API from '../../classes/Api/Api';
import URL from '../../classes/Url/URL';
import Response from '../../classes/Response/Response';
import CustomError from '../../classes/CustomError/CustomError';
import Certificate from '../../classes/Certificate/Certificate';

const CarbonCreditCardService = () => {
  const generateCertificate = async (id) => {
    try {
      const api = new API(`${URL.URL_SERVER}/nft/${id}/certificates`);
      const http_response = await api.post({});
      const has_error = http_response instanceof CustomError;
      return has_error
        ? http_response
        : new Response(http_response, Certificate);
    } catch (error) {
      console.error('Error', error);
      throw error;
    }
  };

  return {
    generateCertificate,
  };
};

export default CarbonCreditCardService;
